export default __webpack_public_path__ + "static/media/p1 copy.292ba20b.png";